import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useObjectRef } from '@react-aria/utils';
import { forwardRef } from 'react';
const Listbox = forwardRef(({ children, className, ...rest }, ref) => {
    const listBoxRef = useObjectRef(ref);
    return (_jsx("ul", { ...rest, className: buildClassName('list-none', 'mb-0 mt-0 pl-0', 'rounded-lg', 'overflow-y-auto overflow-x-hidden', className), ref: listBoxRef, children: children }));
});
export default Listbox;
//# sourceMappingURL=Listbox.js.map